import sliceCreator from '../../index.jsx';
import {GET_SALES_TARGET_BY_ID} from '../../../constants/index.jsx';
const _getSalesTargetByIdAction = sliceCreator('GET_SALES_TARGET_BY_ID', GET_SALES_TARGET_BY_ID, 'get');

const { asyncAction: getSalesTargetByIdAction, reducer, clearData: clearGetSalesTargetByIdAction } = _getSalesTargetByIdAction;

export default reducer;

export {
    getSalesTargetByIdAction,
    clearGetSalesTargetByIdAction
}